import t from "./stateManager.js";
const a = new t();
export {
  a as OrganizationManager,
  a as default
};
//# sourceMappingURL=organizationManager.js.map
